import React, { useState } from 'react';
import InputButton from '../../../Shared/FormComponents/InputButton';
import InputText from '../../../Shared/FormComponents/InputText';
import { forgotUsername } from '../../../../lib/api/user';
import {stripUsernameChars} from '../../../Shared/StringManipulation';
import Form from '../../../Shared/Form';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';

const ForgotUsernameForm = () => {

    const [loading, setLoading] = useState();
    const [success, setSuccess] = useState();
    const history = useHistory()

    const requestUsernameReminder = ({ account, email }, {setStatus, setErrors}) => {
        console.log('running requestUsernameReminder function for account:', account, ' email:', email);
        setLoading(true);
        forgotUsername(account.trim(), email.trim())
            .then(resp => {
                console.log('success', resp);
                setLoading(false);
                setSuccess(true);
                setTimeout(() => {
                    history.push('/login/forgot-username/check-email');
                }, 1000)
            })
            .catch(err => {
                console.log('err', err)
                setLoading(false);
                setSuccess(false);
                setErrors({
                    account: 'Unable to issue username reminder.',
                    email: 'Please check the email and try again.',
                });
            })
    }

    return (
        <div className="w-full max-w-450px m-auto">
            <div className="bg-white w-full rounded-2xl">
                <div className="p-40px sm:p-60px">
                    <h3 className="uppercase text-18px sm:text-16px text-everflow-magenta font-bold text-center">Forgotten your username?</h3>                   
                    <div className="mt-32px">
                        <p className="text-everflow-black text-center">
                                Not sure whether your username is your account number or your email address?<br/>
                                Submit your account number and email and we&apos;ll remind you which one to use.
                        </p>
                        <Form
                            initialValues={{account: '', email: ''}}
                            validationSchema={forgotUsernameSchema}
                            onSubmit={requestUsernameReminder}
                            className="mt-32px grid grid-cols-1 gap-y-24px justify-items-center"
                        >
                                {({values, handleChange, setFieldValue,  errors, touched, handleBlur, handleSubmit}) => {
                                    return(
                                        <>
                                            <InputText
                                                label="Account number"
                                                placeholder="e.g. EFW000000-0 or EFX000000"
                                                className="w-full rounded-28px"
                                                id="account"
                                                req
                                                value={values.account}
                                                error={errors.account}
                                                onChange={ev => stripUsernameChars(ev.target.value, val => setFieldValue('account', val))}
                                                onBlur={handleBlur}
                                                tick={success}
                                            />

                                            <InputText
                                                label="Email address"
                                                placeholder="name@example.com"
                                                className="w-full rounded-28px"
                                                id="email"
                                                req
                                                value={values.email}
                                                error={touched.email ? errors.email : undefined}
                                                onChange={(e) => setFieldValue('email', e.target.value.trim())}
                                                onBlur={handleBlur}
                                                autoComplete="email"
                                                inputMode="email"
                                                name="email"
                                                type="email"
                                                spellCheck={false}
                                                aria-describedby="email-help"
                                                tick={success}
                                            />

                                            <InputButton
                                                id="request-username-reminder-button"
                                                loading={loading}
                                                className="w-full font-bold"
                                                label="Request Username Reminder"
                                                onClick={handleSubmit}
                                            />
                                        </>
                                    )
                                }}
                        </Form>
                    </div>
                </div>
                <div className="p-32px text-center border-t-2 border-gray-default-500">
                    <div>
                        <Link className="underline text-everflow-black" to="/">Return to Login</Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

const forgotUsernameSchema = Yup.object().shape({
    account: Yup.string().required('Please enter your account number'),
    email: Yup.string()
        .email('Please enter a valid email address')
        .required('Please enter your email address'),
})

export default ForgotUsernameForm
